export default __webpack_public_path__ + "static/equilibre_avatar_simon_spychala-a80bd522374681b5935b4cee2cdc70c0.png";